import React from "react";
import { useDispatch } from "react-redux";
import Box from "../../../../components/Box";
import { Helpers } from "../../../../helpers/Helpers";
import { storeImageViewer } from "../../../../redux/reducers/authSlice";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";

interface Props {
    generalInformationRef: any
    code: string | undefined
    setCode: React.Dispatch<React.SetStateAction<string | undefined>>
    name: string | undefined
    setName: React.Dispatch<React.SetStateAction<string | undefined>>
    longName: string | undefined
    setLongName: React.Dispatch<React.SetStateAction<string | undefined>>
    desc: string | undefined
    setDesc: React.Dispatch<React.SetStateAction<string | undefined>>
    isCustomActive: boolean
    setIsCustomActive: React.Dispatch<React.SetStateAction<boolean>>
    phone1Ref: React.MutableRefObject<HTMLInputElement | null>
    phone1: string | undefined
    setPhone1: React.Dispatch<React.SetStateAction<string | undefined>>
    email: string | undefined
    setEmail: React.Dispatch<React.SetStateAction<string | undefined>>
    isBlocked: boolean
    setIsBlocked: React.Dispatch<React.SetStateAction<boolean>>
    blockedDesc: string | undefined
    setBlockedDesc: React.Dispatch<React.SetStateAction<string | undefined>>
    b64: string
    setB64: React.Dispatch<React.SetStateAction<string>>
    setFile: React.Dispatch<React.SetStateAction<File | undefined>>
    fileRef: any
    handleFileRead: (event: any, setFunction: React.Dispatch<React.SetStateAction<string>>) => Promise<void>
    canBeEdited: boolean
}

const GeneralInformation = ({
    generalInformationRef,
    code,
    setCode,
    name,
    setName,
    longName,
    setLongName,
    desc,
    setDesc,
    isCustomActive,
    setIsCustomActive,
    phone1,
    phone1Ref,
    setPhone1,
    email,
    setEmail,
    blockedDesc,
    isBlocked,
    setBlockedDesc,
    setIsBlocked,
    b64,
    setB64,
    setFile,
    fileRef,
    handleFileRead,
    canBeEdited
}: Props) => {
    const dispatch = useDispatch();

    return (
        <div className='containerPart' ref={generalInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                    <div className='row'>
                        <div className="col-md-9">
                            <div className="row">
                                <div className="col-md-6">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Kod</label>
                                        <input disabled style={{ border: '1px solid #F1F1F4' }} value={code} onChange={(e) => setCode(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Kısa Ad</label>
                                        <input disabled={!canBeEdited} style={{ border: '1px solid #F1F1F4' }} value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Fatura Ünvanı</label>
                                        <input disabled={!canBeEdited} style={{ border: '1px solid #F1F1F4' }} value={longName} onChange={(e) => setLongName(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Açıklama</label>
                                        <textarea disabled={!canBeEdited} value={desc} onChange={(e) => setDesc(e.target.value)} style={{ border: '1px solid #F1F1F4', width: '100%', resize: 'none' }} className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <div className="form-check form-check-custom form-check-solid d-flex">
                                            <input disabled={!canBeEdited} onChange={(e) => { setIsCustomActive(!isCustomActive) }} className="form-check-input" type="checkbox" value="" id={"deviceCrudIsCustomActiveYes"} checked={isCustomActive} />
                                            <label className="form-check-label text-gray-800" htmlFor={"deviceCrudIsCustomActiveYes"}>
                                                Aktif
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Telefon 1</label>
                                        <input disabled={!canBeEdited} ref={phone1Ref} style={{ border: '1px solid #F1F1F4' }} value={phone1} onChange={(e) => setPhone1(e.target.value)} className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">E-Posta</label>
                                        <input disabled={!canBeEdited} style={{ border: '1px solid #F1F1F4' }} value={email} onChange={(e) => setEmail(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-10">
                                        <Box flexDirection="row">
                                            <Box mr="15px" justifyContent='flex-start'>
                                                <div className="form-check form-check-custom form-check-solid d-flex">
                                                    <input disabled={!canBeEdited} onChange={(e) => {
                                                        var newVal = !isBlocked;

                                                        if (!newVal)
                                                            setBlockedDesc('');

                                                        setIsBlocked(newVal);
                                                    }} className="form-check-input" type="checkbox" value="" id={"deviceCrudIsBlocked"} checked={isBlocked} />
                                                    <label className="form-check-label text-gray-800" htmlFor={"deviceCrudIsBlocked"}>
                                                        Bloke
                                                    </label>
                                                </div>
                                            </Box>
                                            <Box flexGrow={1}>
                                                <textarea disabled={!canBeEdited || !isBlocked} value={blockedDesc} onChange={(e) => setBlockedDesc(e.target.value)} style={{ border: '1px solid #F1F1F4', width: '100%', height: 200, resize: 'none' }} className="form-control form-control-solid" />
                                            </Box>
                                        </Box>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Şirket Logosu</label>

                            <div>
                                <img onClick={() => dispatch(storeImageViewer([b64]))} style={{ width: '100%' }} className="actionIcon img img-thumbnail" src={b64} />

                                <div className='mt-5 p-3 img img-thumbnail d-flex'>
                                    <div className='d-flex flex-grow-1'>
                                        <input disabled={!canBeEdited} accept="image/*" ref={fileRef} onChange={(e) => { setFile(e && e.target && e.target.files && e.target.files.length > 0 ? e.target.files[0] : undefined); handleFileRead(e, setB64); }} type="file" className="form-control form-control-solid" />
                                    </div>

                                    {
                                        !Helpers.isEmpty(b64) && (
                                            <div style={{ marginLeft: 15 }} className='d-flex align-items-center'>
                                                <i onClick={() => { setFile(undefined); setB64(Helpers.getPlaceholder()); fileRef.current.value = ""; }} style={{ fontSize: 18 }} className='actionIcon text-danger fa fa-trash' />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default GeneralInformation;